import { render, staticRenderFns } from "./UserAssignedVideoToursDropdown.vue?vue&type=template&id=5803842b"
import script from "./UserAssignedVideoToursDropdown.vue?vue&type=script&lang=js"
export * from "./UserAssignedVideoToursDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports